import React, { useState, useEffect } from 'react';
import { Container, Grid, Card, CardContent, Typography, CardMedia, Button, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { serviceImages } from '../assets/images/imageUrls';
import { getDatabase, ref, onValue } from 'firebase/database';
import './Services.css';

function Services() {
  const [vacationMode, setVacationMode] = useState(null);

  useEffect(() => {
    const db = getDatabase();
    const vacationRef = ref(db, 'vacation');
    
    const unsubscribe = onValue(vacationRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.active) {
        setVacationMode({
          startDate: new Date(data.startDate),
          endDate: new Date(data.endDate)
        });
      } else {
        setVacationMode(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const services = [
    {
      title: 'Haircut',
      price: '$25',
      description: 'Professional haircut including consultation and styling',
      image: serviceImages.haircut
    },
    {
      title: 'Beard Trim',
      price: '$20',
      description: 'Expert beard trimming and shaping',
      image: serviceImages.beard
    },
    {
      title: 'Hot Towel Shave',
      price: '$40',
      description: 'Traditional hot towel shave with premium products',
      image: serviceImages.shave
    },
    {
      title: 'Kids Haircut',
      price: '$25',
      description: 'Gentle and patient service for our younger clients',
      image: serviceImages.kids
    },
    {
      title: 'Facial Treatment',
      price: '$40',
      description: 'Relaxing facial treatment for skin rejuvenation',
      image: serviceImages.facial
    },
    {
      title: 'Straight Razor Shave',
      price: '$25',
      description: 'Professional straight razor shave',
      image: serviceImages.straightRazor
    },
    
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }} className="services">
      {vacationMode && (
        <Alert severity="info" sx={{ mb: 4 }}>
          The barber will be on vacation from {vacationMode.startDate.toLocaleDateString()} to {vacationMode.endDate.toLocaleDateString()}. 
          You can still make appointments for any available date.
        </Alert>
      )}
      <Typography variant="h3" component="h1" gutterBottom align="center" className="services-title">
        Our Services
      </Typography>
      <Typography variant="h6" component="p" gutterBottom align="center" sx={{ mb: 6 }} className="services-subtitle">
        Professional grooming services for the modern gentleman
      </Typography>
      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card className="service-card">
              <CardMedia
                component="img"
                height="250"
                image={service.image}
                alt={service.title}
                className="service-image"
              />
              <CardContent className="service-content">
                <Typography variant="h5" component="h2" gutterBottom>
                  {service.title}
                </Typography>
                <Typography variant="h6" color="primary" gutterBottom>
                  {service.price}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {service.description}
                </Typography>
                <Button
                  component={Link}
                  to="/appointment"
                  variant="contained"
                  color="primary"
                  className="book-button"
                >
                  Book Now
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Services;
